export default {
    book_now: 'Varaa nyt',
    minimum_age: 'Vähintään {age} vuotias',
    excess_liability: 'Omavastuu',
    security_deposit: 'Katevarmenne',
    fuel_policy: 'Polttoainekäytäntö',
    like_for_like: 'Vastaavasta vastaavaan',
    full_to_full: 'Täysi',
    miles_per_rental: '{mileage} Ilmaista mailia per vuokraus',
    km_per_rental: '{mileage} Ilmaista kilometriä per vuokraus',
    unlimited_mileage: 'Vapaat kilometrit',
    unlimited_mileage_km: 'Vapaat kilometrit',
    non_amendable: 'Ei muutettavissa',
    non_refundable: 'Peruutukset: Ei Hyvitettävissä',
    free_cancellation_until: 'Ilmainen peruutus päättyy:',
    cancellation_in_line_with: 'Peruutuksen peruste:',
    tcs: 'Vuokraehdot',
    free_extras_on_collection: 'Kaksi ilmaista lisävarustetta noudattaessa',
    glass_and_tyres_covered: 'Tuulilasi ja renkaat katetaan',
    number_of_passengers: 'Matkustajien lukumäärä',
    number_of_bags: 'Laukkujen määrä',
    fuel_type: 'Polttoainetyyppi',
    co2: 'CO2',
    aircon: 'Ilmastointi',
    transmission: 'Vaihteisto',
    book_type: 'Varaa {type}',
    debit_card_deposit: 'Pankkikortti hyväksytty talletuksia varten',
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/fi/quotes/price_card.js